export enum GoPayPaymentState {
	Created = "CREATED",
	Paid = "PAID",
	Canceled = "CANCELED",
	PaymentMethodChosen = "PAYMENT_METHOD_CHOSEN",
	Timeouted = "TIMEOUTED",
	Authorized = "AUTHORIZED",
	Refunded = "REFUNDED",
	PartiallyRefunded = "PARTIALLY_REFUNDED",
}
